/**
 * Authentication constants
 * Centralized keys and endpoints to avoid magic strings
 */

/**
 * Authentication API endpoints
 */
export const AUTH_ENDPOINTS = {
  SIGN_IN: '/auth/sign-in',
  SIGN_UP: '/auth/sign-up',
  SIGN_OUT: '/auth/sign-out',
  REFRESH: '/auth/refresh',
  VERIFY_EMAIL: '/auth/verify-email',
  ME: '/auth/me',
  PASSWORD_FORGOT: '/auth/password/forgot',
  PASSWORD_RESET_PREVIEW: '/auth/password/reset/preview',
  PASSWORD_RESET: '/auth/password/reset',
  PASSWORD_CHANGE: '/auth/password/change',
  PASSWORD_POLICY: '/auth/password/policy',
  /** Open: the link from the new mailbox is opened without a session (core H119). */
  EMAIL_CHANGE_CONFIRM: '/auth/email-change/confirm',
} as const;

/**
 * LocalStorage keys for authentication data
 */
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'agentsbooster_access_token',
  REFRESH_TOKEN: 'agentsbooster_refresh_token',
  USER_DATA: 'agentsbooster_user_data',
  REMEMBER_ME: 'agentsbooster_remember_me',
  SELECTED_AGENT_ID: 'agentsbooster_selected_agent_id',
} as const;

/**
 * Default authentication configuration
 */
export const AUTH_CONFIG = {
  TOKEN_EXPIRY_MS: 3600000, // 1 hour in milliseconds
  REFRESH_THRESHOLD_MS: 300000, // Refresh 5 minutes before expiry
  REMEMBER_ME_DURATION_DAYS: 30,
} as const;
